import { render, staticRenderFns } from "./ForumResponseReactionButton.vue?vue&type=template&id=03221830&scoped=true"
import script from "./ForumResponseReactionButton.vue?vue&type=script&lang=js"
export * from "./ForumResponseReactionButton.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseReactionButton.vue?vue&type=style&index=0&id=03221830&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03221830",
  null
  
)

export default component.exports